import { render, staticRenderFns } from "./SaplingDetailed.vue?vue&type=template&id=1e65acf3&scoped=true"
import script from "./SaplingDetailed.vue?vue&type=script&lang=ts"
export * from "./SaplingDetailed.vue?vue&type=script&lang=ts"
import style0 from "./SaplingDetailed.vue?vue&type=style&index=0&id=1e65acf3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65acf3",
  null
  
)

export default component.exports